<template>
  <div>
    <span>时间范围:&nbsp;&nbsp;</span>
    <a-range-picker
      :allowClear="false"
      style="width: 320px"
      size="small"
      v-model="dateRange"
      :format="
        timeType == 'sec'
          ? 'yyyy-MM-DD HH:mm:ss'
          : timeType == 'min'
          ? 'YYYY-MM-DD HH:mm'
          : timeType == 'hour'
          ? 'YYYY-MM-DD HH'
          : 'YYYY-MM-DD'
      "
      :show-time="
        timeType == 'sec'
          ? { format: 'HH: mm: ss' }
          : timeType == 'min'
          ? { format: 'HH: mm' }
          : timeType == 'hour'
          ? { format: 'HH' }
          : false
      "
      @change="onDateRangeChange"
      @openChange="pickerOpenChange"
      @ok="onDateRangeOk"
      :ranges="ranges[timeType]"
      :disabledDate="disabledDate"
    />
    <!-- <el-date-picker
      v-model="dateRange"
      size="small"
      :type="
        ['sec', 'min', 'hour'].includes(timeType)
          ? 'datetimerange'
          : 'daterange'
      "
      :picker-options="pickerOptions[timeType]"
      align="right"
      :format="
        timeType == 'sec'
          ? 'yyyy-MM-dd HH:mm:ss'
          : timeType == 'min'
          ? 'yyyy-MM-dd HH:mm'
          : timeType == 'hour'
          ? 'yyyy-MM-dd HH'
          : 'yyyy-MM-dd'
      "
      style="width:325px"
    /> -->
  </div>
</template>

<script>
import moment from "moment";
const pickerOptions = {
  sec: {
    shortcuts: [
      {
        text: "最近2h",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 2);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近6h",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 6);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近12h",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 12);
          picker.$emit("pick", [start, end]);
        }
      }
    ]
  },
  min: {
    shortcuts: [
      {
        text: "最近2h",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 2);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近4h",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 4);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近6h",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 6);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近12h",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 12);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近24h",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24);
          picker.$emit("pick", [start, end]);
        }
      }
    ]
  },
  hour: {
    shortcuts: [
      {
        text: "最近一天",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近三天",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近一周",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近一月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        }
      }
    ]
  },
  day: {
    shortcuts: [
      {
        text: "最近1周",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 24 * 1000 * 8);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近1月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 24 * 1000 * 30);
          picker.$emit("pick", [start, end]);
        }
      }
    ]
  },
  week: {
    shortcuts: [
      {
        text: "最近1月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 24 * 1000 * 30);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近3月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 24 * 1000 * 30 * 3);
          picker.$emit("pick", [start, end]);
        }
      }
    ]
  },
  month: {
    shortcuts: [
      {
        text: "最近3月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 24 * 1000 * 30 * 3);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近半年",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 24 * 1000 * 30 * 6);
          picker.$emit("pick", [start, end]);
        }
      },
      {
        text: "最近一年",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 24 * 1000 * 30 * 12);
          picker.$emit("pick", [start, end]);
        }
      }
    ]
  }
};
export default {
  data() {
    return {
      ranges: {},
      pickerOptions,
      dateRange: [moment().subtract(2, "hours"), moment()]
    };
  },
  props: {
    timeType: {
      type: String,
      default: "min"
    }
  },
  watch: {
    timeType() {
      if (this.timeType == "sec") {
        this.dateRange = [moment().subtract(1, "hours"), moment()];
      } else if (this.timeType == "min") {
        this.dateRange = [
          moment()
            .subtract(2, "hours")
            .startOf("minute"),
          moment().startOf("minute")
        ];
      } else if (this.timeType == "hour") {
        this.dateRange = [
          moment()
            .subtract(24, "hours")
            .startOf("hour"),
          moment().startOf("hour")
        ];
      } else if (this.timeType == "day") {
        this.dateRange = [
          moment()
            .subtract(7, "days")
            .startOf("day"),
          moment().startOf("day")
        ];
      } else if (this.timeType == "week") {
        this.dateRange = [
          moment()
            .subtract(30, "days")
            .startOf("day"),
          moment().startOf("day")
        ];
      } else if (this.timeType == "month") {
        this.dateRange = [
          moment()
            .subtract(3, "months")
            .startOf("month"),
          moment().startOf("month")
        ];
      }
      this.$emit("dateRangeChange", this.dateRange);
    }
    // dateRange() {
    //   this.$emit("dateRangeChange", this.dateRange);
    // }
  },
  methods: {
    // 每次打开时间弹框面板时，重新设置时间范围：解决时间为组件挂载时的时分秒问题
    pickerOpenChange(status) {
      this.ranges = {
        sec: {
          最近2小时: [
            moment()
              .subtract(2, "hours")
              .startOf("minute"),
            moment().startOf("minute")
          ],
          最近6小时: [
            moment()
              .subtract(6, "hours")
              .startOf("minute"),
            moment().startOf("minute")
          ],
          最近12小时: [
            moment()
              .subtract(12, "hours")
              .startOf("minute"),
            moment().startOf("minute")
          ]
        },
        min: {
          最近2小时: [
            moment()
              .subtract(2, "hours")
              .startOf("minute"),
            moment().startOf("minute")
          ],
          最近12小时: [
            moment()
              .subtract(12, "hours")
              .startOf("minute"),
            moment().startOf("minute")
          ],
          最近24小时: [
            moment()
              .subtract(24, "hours")
              .startOf("minute"),
            moment().startOf("minute")
          ]
        },
        hour: {
          最近1天: [
            moment()
              .subtract(1, "days")
              .startOf("hour"),
            moment().startOf("hour")
          ],
          最近3天: [
            moment()
              .subtract(3, "days")
              .startOf("hour"),
            moment().startOf("hour")
          ],
          最近7天: [
            moment()
              .subtract(7, "days")
              .startOf("hour"),
            moment().startOf("hour")
          ]
        },
        day: {
          最近1周: [
            moment()
              .subtract(7, "days")
              .startOf("day"),
            moment().startOf("day")
          ],
          最近1月: [
            moment()
              .subtract(30, "days")
              .startOf("day"),
            moment().startOf("day")
          ]
        },
        week: {
          最近1月: [
            moment()
              .subtract(1, "months")
              .startOf("day"),
            moment().startOf("day")
          ],
          最近3月: [
            moment()
              .subtract(3, "months")
              .startOf("day"),
            moment().startOf("day")
          ]
        },
        month: {
          最近3月: [
            moment()
              .subtract(3, "months")
              .startOf("day"),
            moment().startOf("day")
          ],
          最近半年: [
            moment()
              .subtract(6, "months")
              .startOf("day"),
            moment().startOf("day")
          ]
        }
      };
    },
    onDateRangeChange(dates) {
      if (["sec", "min", "hour"].includes(this.timeType)) {
        return;
      }
      this.dateRange = dates;
      this.$emit("dateRangeChange", this.dateRange);
    },
    onDateRangeOk() {
      this.$emit("dateRangeOk", this.dateRange);
      this.$emit("dateRangeChange", this.dateRange);
    },
    disabledDate(current) {
      return current && current > moment();
    }
  }
};
</script>

<style></style>
